/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Label_Enqueue_Success_HintInputs */

const vi_lot_label_enqueue_success_hint = /** @type {(inputs: Lot_Label_Enqueue_Success_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent sẽ in trong vài giây.`)
};

/**

* @param {Lot_Label_Enqueue_Success_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_label_enqueue_success_hint = /** @type {((inputs?: Lot_Label_Enqueue_Success_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Label_Enqueue_Success_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_label_enqueue_success_hint(inputs)
});